export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40573f286c904ea05e62ff18c72c6105c022297608&name=revalidateCommunity!'